import { render, staticRenderFns } from "./enCourseCreOrd.vue?vue&type=template&id=112e33cb&scoped=true&"
import script from "./enCourseCreOrd.vue?vue&type=script&lang=js&"
export * from "./enCourseCreOrd.vue?vue&type=script&lang=js&"
import style0 from "./enCourseCreOrd.vue?vue&type=style&index=0&id=112e33cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e33cb",
  null
  
)

export default component.exports